/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SOFTSKILL_COURSE } from "./actionTypes"
import { addSoftskillCourseError, addSoftskillCourseSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addSoftskillsCourse } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addSoftskillsCourse, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (response.message) throw new Error(response.message)
    yield put(addSoftskillCourseSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(addSoftskillCourseError(error.message))
  }
}

function* softskillCourseAddSaga() {
  yield takeEvery(ADD_SOFTSKILL_COURSE, add)
}

export default softskillCourseAddSaga
